export default __webpack_public_path__ + "static/media/flag.5336b7e5.svg";